module.exports = __webpack_public_path__ + "img/Health-Center-t-25715-133.6c11394c.jpg";